module.exports = __webpack_public_path__ + "static/img/Official Accounts.41917574.png";